import { Radio, RadioGroup, FormControlLabel, Typography } from "@mui/material";
import LoadingSkteleton from "../../../../../../load/loadingSkeleton";
import { useState } from "react";
import Delete from "../../../../../../utils/delete";


export default function RestricaoOptions({ value, onChange, options }) {
    const [open, setOpen] = useState(false);

    return (
        <>
            <RadioGroup name="restricaoAutorizacao" value={value} onChange={onChange}>
                {options.map((item, index) => (
                    <Typography key={item.value} m={1} style={{ position: 'relative' }}>
                        <Delete
                            button={true}
                            url='restricao-autorizacao/delete'
                            id={item._id}
                            open={open}
                            setOpen={setOpen}
                            msg={`Tem certeza que deseja eliminar esta opção`}
                            tipo={'Opção'}
                        />
                        <FormControlLabel
                            value={item.descricao}
                            control={<Radio />}
                            style={{ marginRight: 35 }}
                            label={`${index + 1} - ${item.descricao}`}
                        />
                    </Typography>
                ))}
            </RadioGroup>

            {options.length < 1 && <LoadingSkteleton />}
        </>
    );
}
